<app-sidebar>
	<app-top-bar [auth]="authenticatedUser"></app-top-bar>
	<div class="mb-[9vh] ml-20 text-indigo-100 pb-5" [ngClass]="{'mb-[7vh]':screenHeight<=810, 'mb-[9vh]':screenHeight>810}" >.</div>
	<div class="h-screen">
		<router-outlet></router-outlet>
	</div>
</app-sidebar>